// PARA ONDE O "VOLTAR" LEVA — `T12.3`.
//
// ── O ACHADO, NA LETRA DE QUEM TESTOU (28/09/2026, aos 1:01) ────────────────────────────────
//
//     "Não tem botão de voltar. Eu não consigo voltar de forma fácil para o menu. E eu volto
//      sempre para Meus quadrinhos, e não para o Home. Quando eu volto para Meus quadrinhos, não
//      tem nada."
//
// O registro de ações mostra o custo duas vezes — de 1:04 a 1:08 e de 1:31 a 1:33, ele rolou a
// página até o logo e clicou nele, porque era a única saída para o início.
//
// ── A CAUSA: UM DESTINO FIXO NUMA TELA COM VÁRIAS ENTRADAS ──────────────────────────────────
//
// A escolha de formato tem um botão só, e ele diz **"Voltar para meus quadrinhos"** — sempre, de
// qualquer lugar. Mas dá para chegar aqui de quatro lugares: da página inicial, do menu "Criar",
// da biblioteca vazia e do próprio acervo. Em três dos quatro, esse destino não é de onde a
// pessoa veio; e no caso dele era pior, porque o acervo estava vazio — o botão de voltar levava a
// uma tela que não tinha nada.
//
// ── A DECISÃO, E ELA OLHA O HISTÓRICO EM VEZ DE ADIVINHAR ───────────────────────────────────
//
// O roteador desta aplicação marca a PRIMEIRA entrada do histórico com a chave `"default"`.
// Então:
//
//   · chave diferente de `"default"` → há uma página desta aplicação antes desta, e "voltar" é
//     literalmente voltar: um passo atrás, que é de onde a pessoa veio, qualquer que seja;
//   · chave igual a `"default"` → esta é a primeira tela da visita (link colado, aba nova,
//     recarregar). Não há para onde voltar, e **o início é a resposta honesta** — foi o que ele
//     procurou.
//
// `history.back()` sem essa conferência é a armadilha: na primeira entrada ele sai do site, e a
// pessoa que colou o endereço perde a aplicação inteira num clique chamado "Voltar".
//
// ── E O SEGUNDO DESTINO CONTINUA EXISTINDO ──────────────────────────────────────────────────
//
// "Meus quadrinhos" não desaparece: ele vira o segundo botão, com o nome do lugar. Quem quer o
// acervo continua chegando nele em um clique, e quem quer voltar deixa de ser mandado para lá.

export interface SaidaDaTela {
  /** O texto do botão. */
  rotulo: string;
  /**
   * `"tras"` = um passo atrás no histórico, que é de onde a pessoa veio.
   * Qualquer outro valor é um endereço para onde navegar.
   */
  destino: "tras" | string;
}

/**
 * Para onde o "voltar" desta tela leva.
 *
 * @param chaveDoHistorico `useLocation().key` — `"default"` na primeira entrada da visita.
 */
export function paraOndeOVoltarLeva(chaveDoHistorico: string): SaidaDaTela {
  if (chaveDoHistorico && chaveDoHistorico !== "default") {
    // SEM NOMEAR O DESTINO, de propósito: o destino é "de onde você veio", e escrever o nome de
    // uma das quatro entradas possíveis seria errar em três.
    return { rotulo: "Voltar", destino: "tras" };
  }
  return { rotulo: "Voltar ao início", destino: "/" };
}

/** O segundo botão, que é o destino nomeado. Sempre o mesmo, e é por isso que é constante. */
export const SAIDA_PARA_O_ACERVO: SaidaDaTela = {
  rotulo: "Meus quadrinhos",
  destino: "/meus-quadrinhos",
};
